import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  InputNumber,
  Row,
  Col,
  Select,
  useSelect,
  Divider,
  Spin,
  Button,
  Typography,
  notification,
} from '@pankod/refine-antd'
import { getFilteredQuestions } from 'gql/query'
import type { NotificationPlacement } from 'antd/es/notification'
import { useGetIdentity, useTable } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import {
  IBloomLevel,
  ICompetency,
  IDifficultyLevel,
  IGrade,
  IQuestion,
  IQuestionStatus,
  IQuestionType,
  IReportTheme,
  IStrand,
  ISubject,
  ISubTheme,
  ITheme,
  ITNTaxonomy,
  ITopic,
  IWorkRequest,
} from 'interfaces'
import React from 'react'
import { useState } from 'react'
import { CSVLink } from 'react-csv'
import { exportToExcel } from 'exportToExcel'
import { createUserHistory } from 'gql/mutations'
import he from 'he'
// import * as fileSaver from 'file-saver'

// import XLSX from 'sheetjs-style'

type exportQuestionsProps = {
  isModalVisible: boolean
  handleOk: any
  handleCancel: any
}
interface OptionArr {
  [key: string]: string
}
// type OptionArr = {
//   ['key']:string
// }
export const ExportQuestionsModal: React.FC<exportQuestionsProps> = ({ isModalVisible, handleOk, handleCancel }) => {
  const { data: user } = useGetIdentity()
  const [form] = Form.useForm<IQuestion>()

  const [loading, setLoading] = useState(false)
  const [uploading, setUploading] = useState(false)
  const [fileName, setFile] = useState('')
  const { userRole } = useUserContext()
  const [showDownloadBtn, setShowDownloadBtn] = useState(false)
  const [tableData, setTableData] = useState<object[]>([])
  const [showErrMsg, setShowErrorMsg] = useState(false)
  const [getQuestionLoading, setGetQuestions] = useState(false)
  // const [file, setFile] = useState<FileDetails>()
  const fileReader = new FileReader()
  const [array, setArray] = useState<object[]>([])

  // useEffect(() => {
  //   let arr: object[] = []
  //   let optionText = ['option_a', 'option_b', 'option_c', 'option_d']
  //   let optionFlags = ['option_flag_a', 'option_flag_b', 'option_flag_c', 'option_flag_d']
  //   let option_arr: object[] = []
  //   let option_flag_arr: object[] = []
  //   let correct_ans: string = ''
  //   let insight_arr: object[] = []
  //   let insightText = ['insight_a', 'insight_b', 'insight_c', 'insight_d']
  //   let left_label_text = ['left_label_1', 'left_label_2', 'left_label_3', 'left_label_4']
  //   let left_label_arr: object[] = []
  //   let right_label_text = ['right_label_1', 'right_label_2', 'right_label_3', 'right_label_4']
  //   let right_label_arr: object[] = []
  //   let rating_arr: object[] = []
  //   let rating_text = ['rating_1', 'rating_2', 'rating_3', 'rating_4']
  //   let component_arr: object[] = []
  //   let component_text = ['component_1', 'component_2', 'component_3', 'component_4']

  //   let weightage_arr: object[] = []
  //   let weightage_text = ['weightage_1', 'weightage_2', 'weightage_3', 'weightage_4']

  //   exportQuestions().then((response: any) => {
  //     // setCreatorList(response.users)

  //     if (response?.questions?.length > 0) {
  //       response?.questions?.map((item: any, index: any) => {
  //         if (item?.question_type_id == 'MCQ') {
  //           option_arr = []
  //           left_label_arr = []
  //           right_label_arr = []
  //           correct_ans = ''
  //           insight_arr = []
  //           option_flag_arr = []
  //           item?.option_details !== null &&
  //             item?.option_details?.length > 0 &&
  //             item?.option_details?.map((option: any, i: any) => {
  //               // arr[index][optionText[i]]= option?.option_text

  //               option_arr.push({
  //                 [optionText[i]]: option?.option_text,
  //               })

  //               if (option?.option_flag === 'Right Answer') {
  //                 correct_ans = option?.option_text
  //               }
  //               option_flag_arr.push({
  //                 [optionFlags[i]]: option?.option_flag,
  //               })
  //               insight_arr.push({
  //                 [insightText[i]]: option?.option_insight,
  //               })
  //             })
  //         } else if (item?.question_type_id == 'Fill') {
  //           option_arr = []
  //           left_label_arr = []
  //           right_label_arr = []
  //           correct_ans = ''
  //           insight_arr = []
  //           item?.option_details !== null &&
  //             item?.option_details?.length > 0 &&
  //             item?.option_details?.map((option: any, i: any) => {
  //               correct_ans = correct_ans?.concat(option?.right_answer)
  //               correct_ans = correct_ans?.concat(',')
  //             })
  //         } else if (item?.question_type_id == 'Match') {
  //           option_arr = []
  //           left_label_arr = []
  //           right_label_arr = []
  //           correct_ans = ''
  //           insight_arr = []

  //           item?.option_details !== null &&
  //             item?.option_details?.length > 0 &&
  //             item?.option_details?.map((option: any, i: any) => {
  //               left_label_arr.push({
  //                 [left_label_text[i]]: option?.left_label_text,
  //               })
  //               right_label_arr.push({
  //                 [right_label_text[i]]: option?.right_label_text,
  //               })

  //               insight_arr.push({
  //                 [insightText[i]]: option?.option_insight,
  //               })
  //             })
  //         } else {
  //           option_arr = []
  //           left_label_arr = []
  //           right_label_arr = []
  //           correct_ans = ''
  //           insight_arr = []
  //           rating_arr = []
  //           component_arr = []
  //           weightage_arr = []

  //           item?.option_details !== null &&
  //             item?.option_details?.length > 0 &&
  //             item?.option_details?.map((option: any, i: any) => {
  //               component_arr.push(option)
  //             })
  //         }

  //         arr.push({
  //           subject_code: item?.subject?.code,
  //           subject: item?.subject?.name,
  //           theme: item?.theme?.name,
  //           sub_theme: item?.sub_theme?.name,
  //           topic: item?.topic?.name,
  //           grade: item?.grade?.name,
  //           taxonomy: item?.tn_taxonomy?.name,
  //           difficulty_level: item?.difficulty_level?.name,
  //           bloom_level: item?.bloom_level?.name,
  //           strand: item?.strand?.name,
  //           status: item?.status,
  //           creator: item?.userByCreatorId?.displayName,
  //           question_type: item?.question_type_id,
  //           title: item?.title?.replace(/<[^>]+>/g, ''),
  //           options: option_arr,
  //           option_flags: option_flag_arr,
  //           left_label_arr: left_label_arr,
  //           right_label_arr: right_label_arr,
  //           correct_answer: correct_ans,
  //           insight: insight_arr,
  //           rating_arr: rating_arr,
  //           component_name: component_arr,
  //           weightage: weightage_arr,
  //           creator_comments: item?.creator_notes,
  //           reviewer_comments: item?.reviewer_notes,
  //           approver_comments: item?.approver_notes,

  //           reviewer_stem_comments: item?.reviewer_stem_comments,
  //           approver_stem_comments: item?.approver_stem_comments,
  //           question_insight: item?.question_insight,
  //         })
  //       })
  //     }
  //   })

  //   setTableData(arr)
  // }, [])
  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    resource: 'subjects',
    queryOptions: { enabled: isModalVisible },
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { selectProps: gradeSelectProps } = useSelect<IGrade>({
    resource: 'grades',
    queryOptions: { enabled: isModalVisible },
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'eq',
        value: `${parseInt(value)}`,
      },
    ],
  })
  const { selectProps: statusSelectProps } = useSelect<IQuestionStatus>({
    resource: 'question_statuses',
    queryOptions: { enabled: isModalVisible },
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { selectProps: workRequestSelectProps } = useSelect<IWorkRequest>({
    resource: 'work_requests',
    queryOptions: { enabled: isModalVisible },
    fetchSize: 10000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    resource: 'question_types',
    queryOptions: { enabled: isModalVisible },
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const onFinish = (values: any) => {
    let arr: object[] = []
    setGetQuestions(true)
    getFilteredQuestions(values).then((resp: any) => {
      if (resp?.questions?.length > 0) {
        // console.log(resp?.questions, 'response questions')
        setShowErrorMsg(false)
        let optionText = ['option_a', 'option_b', 'option_c', 'option_d']
        let optionFlags = ['option_flag_a', 'option_flag_b', 'option_flag_c', 'option_flag_d']
        let option_arr: OptionArr = {}
        let option_flag_arr: OptionArr = {}
        let correct_ans: string = ''
        let insight_arr: OptionArr = {}
        let insightText = ['insight_a', 'insight_b', 'insight_c', 'insight_d']
        let left_label_text = ['left_label_1', 'left_label_2', 'left_label_3', 'left_label_4']
        let left_label_arr: OptionArr = {}
        let right_label_text = ['right_label_1', 'right_label_2', 'right_label_3', 'right_label_4']
        let right_label_arr: OptionArr = {}
        let rating_arr: OptionArr = {}
        let rating_text1 = ['rating_1_a', 'rating_1_b', 'rating_1_c', 'rating_1_d']
        let rating_text2 = ['rating_2_a', 'rating_2_b', 'rating_2_c', 'rating_2_d']
        let rating_text3 = ['rating_3_a', 'rating_3_b', 'rating_3_c', 'rating_3_d']
        let rating_text4 = ['rating_4_a', 'rating_4_b', 'rating_4_c', 'rating_4_d']
        let component_arr: OptionArr = {}
        let component_text = ['component_1', 'component_2', 'component_3', 'component_4']

        let weightage_arr: OptionArr = {}
        let weightage_text = ['weightage_1', 'weightage_2', 'weightage_3', 'weightage_4']

        resp?.questions?.map((item: any, index: any) => {
          if (item.title) {
            item.title = item.title
              .replace(/<sup>/g, '!#!')
              .replace(/<\/sup>/g, '!##!')
              .replace(/<sub>/g, '!%!')
              .replace(/<\/sub>/g, '!%%!')
            const text = new DOMParser().parseFromString(item?.title, 'text/html')
            const imageInclude = text?.body.querySelector('img')?.src
            if (text.body.textContent || imageInclude) {
              let pTagRemovedValue = text.body.textContent ? text.body.textContent.replace(/,/g, '!@!').replace(/"/g, "''") : ''
              let supAddedValue =
                pTagRemovedValue !== ''
                  ? pTagRemovedValue.replace(/!#!/g, '<sup>').replace(/!##!/g, '</sup>').replace(/!%!/g, '<sub>').replace(/!%%!/g, '</sub>')
                  : ''

              if (imageInclude) {
                supAddedValue = `${supAddedValue} <img src='${imageInclude}'>`
              }
              item.title = he.decode(supAddedValue)
            }
          }

          if (item?.question_type_id == 'MCQ') {
            option_arr = {}
            left_label_arr = {}
            right_label_arr = {}
            correct_ans = ''
            insight_arr = {}
            option_flag_arr = {}
            item?.option_details !== null &&
              item?.option_details?.length > 0 &&
              item?.option_details?.map((option: any, i: any) => {
                // arr[index][optionText[i]]= option?.option_text
                if (option.option_text) {
                  option.option_text = option.option_text
                    .replace(/<sup>/g, '!#!')
                    .replace(/<\/sup>/g, '!##!')
                    .replace(/<sub>/g, '!%!')
                    .replace(/<\/sub>/g, '!%%!')
                }

                let optionTextFromDom = new DOMParser().parseFromString(option?.option_text, 'text/html')
                let optionImageInclude = optionTextFromDom?.body.querySelector('img')?.src
                let optionTextAddedTags = optionTextFromDom.body.textContent
                  ? optionTextFromDom.body.textContent
                    .replace(/!#!/g, '<sup>')
                    .replace(/!##!/g, '</sup>')
                    .replace(/!%!/g, '<sub>')
                    .replace(/!%%!/g, '</sub>')
                  : ''
                let optionTextRemoveLineBreak = optionTextAddedTags
                  ? optionTextAddedTags.replace(/\n/g, '').replace(/,/g, '!@!').replace(/"/g, "''")
                  : ''
                let isImageAddedOption = optionImageInclude
                  ? `${optionTextRemoveLineBreak ? optionTextRemoveLineBreak : ''} <img src='${optionImageInclude}'>`
                  : `${optionTextRemoveLineBreak}`
                let isOptionText = isImageAddedOption
                option.option_text = he.decode(isOptionText)

                option_arr = {
                  ...option_arr,
                  [optionText[i]]: option?.option_text,
                }
                // option_arr.push({

                // })
                if (option.option_insight) {
                  option.option_insight = option.option_insight
                    .replace(/<sup>/g, '!#!')
                    .replace(/<\/sup>/g, '!##!')
                    .replace(/<sub>/g, '!%!')
                    .replace(/<\/sub>/g, '!%%!')
                  let optionInsightFromDom = new DOMParser().parseFromString(option?.option_insight, 'text/html')
                  let optionImageInclude = optionInsightFromDom?.body.querySelector('img')?.src
                  let optionInsightAddedTags = optionInsightFromDom.body.textContent
                    ? optionInsightFromDom.body.textContent
                      .replace(/!#!/g, '<sup>')
                      .replace(/!##!/g, '</sup>')
                      .replace(/!%!/g, '<sub>')
                      .replace(/!%%!/g, '</sub>')
                    : ''
                  let optionInsightRemoveLineBreak = optionInsightAddedTags
                    ? optionInsightAddedTags.replace(/\n/g, '').replace(/,/g, '!@!').replace(/"/g, "''")
                    : ''
                  let isImageAddedOption = optionImageInclude
                    ? `${optionInsightRemoveLineBreak ? optionInsightRemoveLineBreak : ''} <img src='${optionImageInclude}'>`
                    : `${optionInsightRemoveLineBreak}`
                  let isOptionInsight = isImageAddedOption
                  option.option_insight = he.decode(isOptionInsight)
                }

                if (option?.option_flag === 'Right Answer') {
                  correct_ans = option?.option_text
                }
                option_flag_arr = {
                  ...option_flag_arr,
                  [optionFlags[i]]: option?.option_flag,
                }
                insight_arr = {
                  ...insight_arr,
                  [insightText[i]]: option?.option_insight,
                }
                // option_flag_arr.push({
                //   [optionFlags[i]]: option?.option_flag,
                // })
                // insight_arr.push({
                //   [insightText[i]]: option?.option_insight,
                // })
              })
          } else if (item?.question_type_id === 'Fill') {
            option_arr = {}
            left_label_arr = {}
            right_label_arr = {}
            correct_ans = ''
            insight_arr = {}
            item?.option_details !== null &&
              item?.option_details?.length > 0 &&
              item?.option_details?.map((option: any, i: any) => {
                if (option.right_answer) {
                  option.right_answer = option.right_answer
                    .replace(/<sup>/g, '!#!')
                    .replace(/<\/sup>/g, '!##!')
                    .replace(/<sub>/g, '!%!')
                    .replace(/<\/sub>/g, '!%%!')
                }

                if (option?.option_insights || option?.option_insight) {
                  const optionInsights = option?.option_insights || option?.option_insight || ''
                  option.option_insights = optionInsights
                    .replace(/<sup>/g, '!#!')
                    .replace(/<\/sup>/g, '!##!')
                    .replace(/<sub>/g, '!%!')
                    .replace(/<\/sub>/g, '!%%!')
                    .replace(/<strong>/g, '[b]')
                    .replace(/<\/strong>/g, '[/b]')
                    .replace(/<u>/g, '[u]')
                    .replace(/<\/u>/g, '[/u]')
                    .replace(/<em>/g, '[i]')
                    .replace(/<\/em>/g, '[/i]')
                  let optionInsightFromDom = new DOMParser().parseFromString(option?.option_insights, 'text/html')
                  let optionImageInclude = optionInsightFromDom?.body.querySelector('img')?.src
                  let optionInsightAddedTags = optionInsightFromDom.body.textContent
                    ? optionInsightFromDom.body.textContent
                      .replace(/!#!/g, '<sup>')
                      .replace(/!##!/g, '</sup>')
                      .replace(/!%!/g, '<sub>')
                      .replace(/!%%!/g, '</sub>')
                    : ''
                  let optionInsightRemoveLineBreak = optionInsightAddedTags
                    ? optionInsightAddedTags.replace(/\n/g, '').replace(/,/g, '!@!').replace(/"/g, "''")
                    : ''
                  let isImageAddedOption = optionImageInclude
                    ? `${optionInsightRemoveLineBreak ? optionInsightRemoveLineBreak : ''} <img src='${optionImageInclude}'>`
                    : `${optionInsightRemoveLineBreak}`
                  let isOptionInsight = isImageAddedOption
                  option.option_insights = he.decode(isOptionInsight)
                }

                insight_arr = {
                  ...insight_arr,
                  [insightText[i]]: option?.option_insights,
                }

                let optionTextFromDom = new DOMParser().parseFromString(option?.right_answer, 'text/html')
                let optionImageInclude = optionTextFromDom?.body.querySelector('img')?.src
                let optionTextAddedTags = optionTextFromDom.body.textContent
                  ? optionTextFromDom.body.textContent
                    .replace(/!#!/g, '<sup>')
                    .replace(/!##!/g, '</sup>')
                    .replace(/!%!/g, '<sub>')
                    .replace(/!%%!/g, '</sub>')
                  : ''
                let optionTextRemoveLineBreak = optionTextAddedTags
                  ? optionTextAddedTags.replace(/\n/g, '').replace(/,/g, '!@!').replace(/"/g, "''")
                  : ''
                let isImageAddedOption = optionImageInclude
                  ? `${optionTextRemoveLineBreak ? optionTextRemoveLineBreak : ''} <img src='${optionImageInclude}'>`
                  : `${optionTextRemoveLineBreak}`
                let optionText = isImageAddedOption !== '' || isImageAddedOption !== undefined ? optionTextRemoveLineBreak : ''
                option.right_answer = he.decode(optionText)

                correct_ans = correct_ans?.concat(option?.right_answer)
                if (item?.option_details?.length > i) correct_ans = correct_ans?.concat(',')
              })
          } else if (item?.question_type_id === 'Match') {
            option_arr = {}
            left_label_arr = {}
            right_label_arr = {}
            correct_ans = ''
            insight_arr = {}

            item?.option_details !== null &&
              item?.option_details?.length > 0 &&
              item?.option_details?.map((option: any, i: any) => {
                if (option.left_label_text) {
                  option.left_label_text = option.left_label_text
                    .replace(/<sup>/g, '!#!')
                    .replace(/<\/sup>/g, '!##!')
                    .replace(/<sub>/g, '!%!')
                    .replace(/<\/sub>/g, '!%%!')
                }
                if (option.right_label_text) {
                  option.right_label_text = option.right_label_text
                    .replace(/<sup>/g, '!#!')
                    .replace(/<\/sup>/g, '!##!')
                    .replace(/<sub>/g, '!%!')
                    .replace(/<\/sub>/g, '!%%!')
                }

                let optionLeftTextFromDom = new DOMParser().parseFromString(option?.left_label_text, 'text/html')
                let optionRightTextFromDom = new DOMParser().parseFromString(option?.right_label_text, 'text/html')
                let optionImageIncludeInLeft = optionLeftTextFromDom?.body.querySelector('img')?.src
                let optionImageIncludeInRight = optionRightTextFromDom?.body.querySelector('img')?.src
                let optionLeftTextAddedTags = optionLeftTextFromDom.body.textContent
                  ? optionLeftTextFromDom.body.textContent
                    .replace(/!#!/g, '<sup>')
                    .replace(/!##!/g, '</sup>')
                    .replace(/!%!/g, '<sub>')
                    .replace(/!%%!/g, '</sub>')
                  : ''
                let optionLeftTextRemoveLineBreak = optionLeftTextAddedTags
                  ? optionLeftTextAddedTags.replace(/\n/g, '').replace(/,/g, '!@!').replace(/"/g, "''")
                  : ''
                let optionRightTextAddedTags = optionRightTextFromDom.body.textContent
                  ? optionRightTextFromDom.body.textContent
                    .replace(/!#!/g, '<sup>')
                    .replace(/!##!/g, '</sup>')
                    .replace(/!%!/g, '<sub>')
                    .replace(/!%%!/g, '</sub>')
                  : ''
                let optionRightTextRemoveLineBreak = optionRightTextAddedTags
                  ? optionRightTextAddedTags.replace(/\n/g, '').replace(/,/g, '!@!').replace(/"/g, "''")
                  : ''
                let isImageAddedLeftOption = optionImageIncludeInLeft
                  ? `${optionLeftTextRemoveLineBreak ? optionLeftTextRemoveLineBreak : ''} <img src='${optionImageIncludeInLeft}'>`
                  : `${optionLeftTextRemoveLineBreak}`
                let isImageAddedRightOption = optionImageIncludeInRight
                  ? `${optionRightTextRemoveLineBreak ? optionRightTextRemoveLineBreak : ''} <img src='${optionImageIncludeInRight}'>`
                  : `${optionRightTextRemoveLineBreak}`

                let optionLeftText = isImageAddedLeftOption !== '' || isImageAddedLeftOption !== undefined ? optionLeftTextRemoveLineBreak : ''
                option.left_label_text = he.decode(optionLeftText)
                let optionRightText = isImageAddedRightOption !== '' || isImageAddedRightOption !== undefined ? optionRightTextRemoveLineBreak : ''
                option.left_label_text = he.decode(optionLeftText)
                option.right_label_text = he.decode(optionRightText)

                left_label_arr = {
                  ...left_label_arr,
                  [left_label_text[i]]: option?.left_label_text,
                }
                right_label_arr = {
                  ...right_label_arr,
                  [right_label_text[i]]: option?.right_label_text,
                }

                if (option.option_insight) {
                  option.option_insight = option.option_insight
                    .replace(/<sup>/g, '!#!')
                    .replace(/<\/sup>/g, '!##!')
                    .replace(/<sub>/g, '!%!')
                    .replace(/<\/sub>/g, '!%%!')
                  let optionInsightFromDom = new DOMParser().parseFromString(option?.option_insight, 'text/html')
                  let optionImageInclude = optionInsightFromDom?.body.querySelector('img')?.src
                  let optionInsightAddedTags = optionInsightFromDom.body.textContent
                    ? optionInsightFromDom.body.textContent
                      .replace(/!#!/g, '<sup>')
                      .replace(/!##!/g, '</sup>')
                      .replace(/!%!/g, '<sub>')
                      .replace(/!%%!/g, '</sub>')
                    : ''
                  let optionInsightRemoveLineBreak = optionInsightAddedTags
                    ? optionInsightAddedTags.replace(/\n/g, '').replace(/,/g, '!@!').replace(/"/g, "''")
                    : ''
                  let isImageAddedOption = optionImageInclude
                    ? `${optionInsightRemoveLineBreak ? optionInsightRemoveLineBreak : ''} <img src='${optionImageInclude}'>`
                    : `${optionInsightRemoveLineBreak}`
                  let isOptionInsight = isImageAddedOption
                  option.option_insight = he.decode(isOptionInsight)
                }

                insight_arr = {
                  ...insight_arr,
                  [insightText[i]]: option?.option_insight,
                }
              })
          } else {
            option_arr = {}
            left_label_arr = {}
            right_label_arr = {}
            correct_ans = ''
            insight_arr = {}
            rating_arr = {}
            component_arr = {}
            weightage_arr = {}
            // console.log('itemmmmm', item?.option_details)
            // item?.option_details !== null &&
            //   item?.option_details?.length > 0 ?

            // for (let i = 0; i < component_text?.length; i++){

            //    component_arr = {
            //       ...component_arr,
            //       item?.option_details[i]
            //     }
            // }

            item?.option_details !== null &&
              item?.option_details?.length > 0 &&
              item?.option_details?.map((option: any, i: any) => {
                component_arr = {
                  ...component_arr,
                  [component_text[i]]: option?.component_name,
                  [rating_text1[i]]: option?.rating_1,
                  [rating_text2[i]]: option?.rating_2,
                  [rating_text3[i]]: option?.rating_3,
                  [rating_text4[i]]: option?.rating_4,
                  [weightage_text[i]]: option?.weightage,
                }
                // rating_arr = {
                //   ...rating_arr,
                //   [component_text[i]]: option?.component_name,
                // }
                // component_arr = {
                //   ...component_arr,
                //   [component_text[i]]: option?.component_name,
                // }
                // console.log({ option })
                // component_arr.push(option)
              })
            // console.log({ component_arr })
          }
          let grade_text = ''
          if (item?.question_grades?.length > 0) {
            grade_text = item?.question_grades.map((item: any) => `${item?.grade?.name}`).join(',')
          }

          // console.log({ grade_text })
          arr.push({
            'Subject Code': item?.subject?.code,
            Subject: item?.subject?.name,
            Theme: item?.theme?.name,
            'Sub Theme': item?.sub_theme?.name,
            Topic: item?.topic?.name,
            Grade: grade_text,
            Taxonomy: item?.tn_taxonomy?.name,
            'Difficulty Level': item?.difficulty_level?.name,
            'Blooms Level': item?.bloom_level?.name,
            Strand: item?.strand?.name,
            Status: item?.status,
            Creator: item?.userByCreatorId?.displayName,
            'Question Type': item?.question_type_id,
            Title: item?.title,
            // option_arr,
            'Option A': option_arr?.option_a,
            'Option B': option_arr?.option_b,
            'Option C': option_arr?.option_c,
            'Option D': option_arr?.option_d,
            'Option A Flag': option_flag_arr?.option_flag_a,
            'Option B Flag': option_flag_arr?.option_flag_b,
            'Option C Flag': option_flag_arr?.option_flag_c,
            'Option D Flag': option_flag_arr?.option_flag_d,

            'Correct Answer': correct_ans,
            'Left Label A': left_label_arr?.left_label_1,
            'Right Label A': right_label_arr?.right_label_1,
            'Left Label B': left_label_arr?.left_label_2,
            'Right Label B': right_label_arr?.right_label_2,
            'Left Label C': left_label_arr?.left_label_3,
            'Right Label C': right_label_arr?.right_label_3,
            'Left Label D': left_label_arr?.left_label_4,
            'Right Label D': right_label_arr?.right_label_4,
            'Insight A': insight_arr?.insight_a,
            'Insight B': insight_arr?.insight_b,
            'Insight C': insight_arr?.insight_c,
            'Insight D': insight_arr?.insight_d,
            'Component A': component_arr?.component_1,
            'Component A Rating 1': component_arr?.rating_1_a,
            'Component A Rating 2': component_arr?.rating_2_a,
            'Component A Rating 3': component_arr?.rating_3_a,
            'Component A Rating 4': component_arr?.rating_4_a,
            'Compinet A Weightage': component_arr?.weightage_1,
            'Component B': component_arr?.component_2,
            'Component B Rating 1': component_arr?.rating_1_b,
            'Component B Rating 2': component_arr?.rating_2_b,
            'Component B Rating 3': component_arr?.rating_3_b,
            'Component B Rating 4': component_arr?.rating_4_b,
            'Component B Weightage': component_arr?.weightage_2,
            'Component C': component_arr?.component_3,
            'Component C Rating 1': component_arr?.rating_1_c,
            'Component C Rating 2': component_arr?.rating_2_c,
            'Component C Rating 3': component_arr?.rating_3_c,
            'Component C Rating 4': component_arr?.rating_4_c,
            'Component C Weightage': component_arr?.weightage_3,
            'Component D': component_arr?.component_4,
            'Component D Rating 1': component_arr?.rating_1_d,
            'Component D Rating 2': component_arr?.rating_2_d,
            'Component D Rating 3': component_arr?.rating_3_d,
            'Component D Rating 4': component_arr?.rating_4_d,
            'Component D Weightage': component_arr?.weightage_4,
            'Creator Comments': item?.creator_notes,
            'Reviewer Comments': item?.reviewer_notes,
            'Approver Comments': item?.approver_notes,

            'Reviewer Stem Comments': item?.reviewer_stem_comments,
            'Approver Stem Comments': item?.approver_stem_comments,
            'Question Insight': item?.question_insight,
            'Question ID': item?.question_id,
          })
          // console.log({ arr })
        })
        setTableData(arr)
        setGetQuestions(false)
        setShowDownloadBtn(true)
      } else {
        setShowErrorMsg(true)
      }
    })
  }
  const exportData = () => {
    exportToExcel(tableData, `Questions_${Math.round(new Date().getTime() / 1000)}.xlsx`)
    setTableData([])
    setShowDownloadBtn(false)
    createUserHistory('questions', 'export', '', user?.id, userRole)
    form?.resetFields()
  }
  const cancelPopUp = () => {
    setShowDownloadBtn(false)
    form?.resetFields()
    handleCancel()
  }
  return (
    <Modal
      visible={isModalVisible}
      width={800}
      onCancel={cancelPopUp}
      title={`Export Questions`}
      footer={[
        <Button key="back" onClick={cancelPopUp}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" loading={getQuestionLoading} onClick={form.submit}>
          Get Questions
        </Button>,
        <>
          {showDownloadBtn && (
            <Button onClick={() => exportData()}>Download</Button>
            // <CSVLink
            //   data={tableData}
            //   asyncOnClick={true}
            //   filename={`Questions_${Math.round(new Date().getTime() / 1000)}.xlsx`}
            //   className="ant-btn ant-btn-default"
            //   headers={headers}
            // >
            // Download
            // </CSVLink>
          )}
        </>,
      ]}
    >
      <Form form={form} size="large" layout="vertical" onFinish={onFinish}>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item label="Question Type" name="question_type_ids" rules={[{ required: false }]}>
              <Select mode="multiple" {...questionTypeSelectProps} allowClear showSearch />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Subject" name="subject_ids" rules={[{ required: false }]}>
              <Select mode="multiple" {...subjectSelectProps} allowClear showSearch />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Grades" name="grade_ids" rules={[{ required: false }]}>
              <Select
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                mode="multiple"
                {...gradeSelectProps}
                allowClear
                showSearch
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Status" name="status_ids" rules={[{ required: false }]}>
              <Select mode="multiple" {...statusSelectProps} allowClear showSearch />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Work Requests" name="work_requests" rules={[{ required: false }]}>
              <Select mode="multiple" {...workRequestSelectProps} allowClear showSearch />
            </Form.Item>
          </Col>
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Report Theme (TN_Term_Month)" name="report_theme_id" rules={[{ required: false }]}>
              <Select
                {...reportThemeSelectProps}
                disabled={form?.getFieldValue('subject_id') === undefined || form?.getFieldValue('subject_id') == null ? true : false}
                onChange={handleReportThemeChange}
                allowClear
              />
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Theme (TN Chapter Name)" name="theme_id" rules={[{ required: false }]}>
              <Select
                onChange={handleThemeChange}
                showSearch
                allowClear
                disabled={form?.getFieldValue('report_theme_id') === undefined || form?.getFieldValue('report_theme_id') == null ? true : false}
              >
                {themeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
            <Form.Item
              label="Sub-theme(CENTA ConceptID_CENTA Concept Name)"
              style={{ overflow: 'hidden', height: '100%' }}
              name="sub_theme_id"
              rules={[{ required: false }]}
            >
              <Select
                onChange={handleSubThemeChange}
                allowClear
                disabled={form?.getFieldValue('theme_id') === undefined || form?.getFieldValue('theme_id') == null ? true : false}
              >
                {subThemeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Topic" name="topic_id" rules={[{ required: false }]}>
            
              <Select
                allowClear
                disabled={form?.getFieldValue('sub_theme_id') === undefined || form?.getFieldValue('sub_theme_id') == null ? true : false}
              >
                {tableQueryResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}
        </Row>
        {/* <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Tags
            </Divider>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Competency" name="competency_id" rules={[{ required: false }]}>
              <Select allowClear onChange={handleCompetencyChange} {...competencySelectProps} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Taxonomy" name="tn_taxonomy_id" rules={[{ required: false }]}>
              <Select allowClear onChange={handleTaxonomyChange} {...tntaxonomySelectProps} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Standard" name="strand_id" rules={[{ required: false }]}>
              <Select allowClear {...strandSelectProps} />
            </Form.Item>
          </Col>

          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate Bloom's taxonomy level" name="bloom_level_id" rules={[{ required: false }]}>
              <Select {...bloomlevelSelectProps} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id" rules={[{ required: false }]}>
              <Select {...difficultylevelSelectProps} allowClear />
            </Form.Item>
          </Col>
        </Row> */}
        {/* <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <div className="upload-btn-wrapper1">
              <button className="btnshow">Upload a file</button>
              <input type="file" name="myfile" id={'csvFileInput'} accept={'.csv'} onChange={handleOnChange} onClick={onInputClick} />
            </div>
            <Typography.Text type="success">{fileName}</Typography.Text>
          </Col>
        </Row> */}
        <Spin spinning={loading} tip="Wait...Fetching..." />
        {showErrMsg ? <Typography.Text type="danger">No data found </Typography.Text> : null}

        {/* <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="user_type" initialValue={userRole}>
          <Input type="hidden" />
        </Form.Item> */}
        {/* <Form.Item name="created_by" initialValue={}>
          <Input type="hidden" />
        </Form.Item> */}
      </Form>
    </Modal>
  )
}
